// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LifelineEventEditModal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.LifelineEventEditModal_content {
    background: white;
    border-radius: 12px;
    padding: 24px;
    min-width: 400px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);
}

.LifelineEventEditModal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.LifelineEventEditModal_header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.LifelineEventEditModal_close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.LifelineEventEditModal_close:hover {
    color: #666;
}

.LifelineEventEditModal_form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
}

.LifelineEventEditModal_field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.LifelineEventEditModal_field label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
}

.LifelineEventEditModal_field input,
.LifelineEventEditModal_field textarea {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
}

.LifelineEventEditModal_field input:focus,
.LifelineEventEditModal_field textarea:focus {
    border-color: #14AE5C;
}

.LifelineEventEditModal_field textarea {
    resize: vertical;
    min-height: 60px;
    font-family: inherit;
}

.LifelineEventEditModal_radio_group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.LifelineEventEditModal_radio_label {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: normal !important;
}

.LifelineEventEditModal_radio_label input[type="radio"],
.LifelineEventEditModal_checkbox_label input[type="checkbox"] {
    width: auto;
    margin: 0;
}

.LifelineEventEditModal_checkbox_label {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: normal !important;
}

.LifelineEventEditModal_actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.LifelineEventEditModal_right_actions {
    display: flex;
    gap: 12px;
}

.LifelineEventEditModal_delete {
    background-color: #E23424;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
}

.LifelineEventEditModal_delete:hover:not(:disabled) {
    background-color: #c42e20;
}

.LifelineEventEditModal_cancel {
    background-color: #f5f5f5;
    color: #666;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
}

.LifelineEventEditModal_cancel:hover:not(:disabled) {
    background-color: #eee;
}

.LifelineEventEditModal_save {
    background-color: #14AE5C;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s;
}

.LifelineEventEditModal_save:hover:not(:disabled) {
    background-color: #0f8a47;
}

.LifelineEventEditModal_delete:disabled,
.LifelineEventEditModal_cancel:disabled,
.LifelineEventEditModal_save:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.LifelineEventEditModal_field input[type="date"],
.LifelineEventEditModal_field textarea {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #E0E4E7;
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    transition: border-color 0.2s;
}

.LifelineEventEditModal_field input[type="date"]:focus,
.LifelineEventEditModal_field textarea:focus {
    outline: none;
    border-color: #14AE5C;
}

.LifelineEventEditModal_field input[type="date"].error {
    border-color: #E23424;
    border-width: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/lifeline/LifelineEventEditModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB","sourcesContent":[".LifelineEventEditModal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.LifelineEventEditModal_content {\n    background: white;\n    border-radius: 12px;\n    padding: 24px;\n    min-width: 400px;\n    max-width: 500px;\n    width: 90%;\n    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.LifelineEventEditModal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.LifelineEventEditModal_header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.LifelineEventEditModal_close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #999;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.LifelineEventEditModal_close:hover {\n    color: #666;\n}\n\n.LifelineEventEditModal_form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.LifelineEventEditModal_field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.LifelineEventEditModal_field label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n}\n\n.LifelineEventEditModal_field input,\n.LifelineEventEditModal_field textarea {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.LifelineEventEditModal_field input:focus,\n.LifelineEventEditModal_field textarea:focus {\n    border-color: #14AE5C;\n}\n\n.LifelineEventEditModal_field textarea {\n    resize: vertical;\n    min-height: 60px;\n    font-family: inherit;\n}\n\n.LifelineEventEditModal_radio_group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.LifelineEventEditModal_radio_label {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-weight: normal !important;\n}\n\n.LifelineEventEditModal_radio_label input[type=\"radio\"],\n.LifelineEventEditModal_checkbox_label input[type=\"checkbox\"] {\n    width: auto;\n    margin: 0;\n}\n\n.LifelineEventEditModal_checkbox_label {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-weight: normal !important;\n}\n\n.LifelineEventEditModal_actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n}\n\n.LifelineEventEditModal_right_actions {\n    display: flex;\n    gap: 12px;\n}\n\n.LifelineEventEditModal_delete {\n    background-color: #E23424;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n\n.LifelineEventEditModal_delete:hover:not(:disabled) {\n    background-color: #c42e20;\n}\n\n.LifelineEventEditModal_cancel {\n    background-color: #f5f5f5;\n    color: #666;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n\n.LifelineEventEditModal_cancel:hover:not(:disabled) {\n    background-color: #eee;\n}\n\n.LifelineEventEditModal_save {\n    background-color: #14AE5C;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n\n.LifelineEventEditModal_save:hover:not(:disabled) {\n    background-color: #0f8a47;\n}\n\n.LifelineEventEditModal_delete:disabled,\n.LifelineEventEditModal_cancel:disabled,\n.LifelineEventEditModal_save:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.LifelineEventEditModal_field input[type=\"date\"],\n.LifelineEventEditModal_field textarea {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #E0E4E7;\n    border-radius: 6px;\n    font-size: 14px;\n    font-family: inherit;\n    transition: border-color 0.2s;\n}\n\n.LifelineEventEditModal_field input[type=\"date\"]:focus,\n.LifelineEventEditModal_field textarea:focus {\n    outline: none;\n    border-color: #14AE5C;\n}\n\n.LifelineEventEditModal_field input[type=\"date\"].error {\n    border-color: #E23424;\n    border-width: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
